import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/payment_reminder_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  sales_order_id_eq: {
    column_type: 'belongs_to',
    column_name: 'sales_order',
    extra: {
      model_name: 'SalesOrder',
      value_column: 'id',
    },
    model_name: 'PaymentReminder',
  },
  sales_order: {
    column_type: 'belongs_to',
    column_name: 'sales_order',
    extra: {
      model_name: 'SalesOrder',
      value_column: 'id',
    },
    model_name: 'PaymentReminder',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'PaymentReminder',
      options: ['pending', 'received', 'overdue'],
    },
    model_name: 'PaymentReminder',
    column_name: 'state',
  },
  date_gteq: {
    column_type: 'date',
    model_name: 'PaymentReminder',
    column_name: 'date',
  },
  date_lteq: {
    column_type: 'date',
    model_name: 'PaymentReminder',
    column_name: 'date',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('PaymentReminder', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('PaymentReminder', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
